import { InjectionToken, Signal } from '@angular/core';

/**
 * Contract that each app implements to tell the top bar whether the user has notices
 * that require their attention and how to open them. The data sources are app-specific,
 * so the token is optional: apps without notices simply do not provide it.
 */
export interface ITopBarNotices {
  hasNotices: Signal<boolean>;
  openNotices: () => void;
  labelKey?: string;
}

export const TOP_BAR_NOTICES = new InjectionToken<ITopBarNotices>('TOP_BAR_NOTICES');
